// Patch to preserve custom data attributes when Rails converts link_to with turbo_method to forms
//
// PROBLEM:
// When you use link_to with data: { turbo_method: :post }, Rails automatically converts the link
// into a hidden form submission behind the scenes. However, Rails only transfers certain "approved"
// data attributes to the generated form (like data-turbo-confirm, data-turbo-method, etc.).
//
// Custom data attributes like data-turbo-confirm-description and data-turbo-confirm-text are NOT
// automatically transferred, causing them to be lost when the form is created.
//
// EXAMPLE OF THE PROBLEM:
// <%= link_to "Delete", my_path, data: {
//   turbo_method: :post,
//   turbo_confirm: "Are you sure?",
//   turbo_confirm_description: "This will permanently delete the record"
// } %>
// The turbo_confirm_description is lost when the form is created, and the src/confirm.js modal does not show the description.



document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-turbo-method]');

  if (link) {
    // Store custom attributes on the link element itself for later retrieval
    const customAttrs = {};
    Array.from(link.attributes).forEach(function(attr) {
      if (attr.name.startsWith('data-turbo-confirm-')) {
        customAttrs[attr.name] = attr.value;
      }
    });

    // Use multiple timeouts to catch the form when Rails creates it
    const updateForm = () => {
      const allTurboForms = document.querySelectorAll('form[data-turbo]');

      allTurboForms.forEach(function(form) {
        if (form.action === link.href && !form.hasAttribute('data-turbo-confirm-description')) {
          Object.entries(customAttrs).forEach(function([name, value]) {
            form.setAttribute(name, value);
          });
        }
      });
    };

    // Try immediately and with a small delay as safety net
    updateForm();
    setTimeout(updateForm, 5);
  }
});